import React from 'react';
import { Calculator, Loader2 } from 'lucide-react';

export interface LaborEstimationItem {
  name: string;
  count: number;
  status: 'pending' | 'processing' | 'complete' | 'error';
}

export interface LaborEstimationIndicatorProps {
  show: boolean;
  laborEstimationProgress: LaborEstimationItem[];
  showEstimatePopover: boolean;
  onTogglePopover: () => void;
}

export const LaborEstimationIndicator: React.FC<LaborEstimationIndicatorProps> = ({
  show,
  laborEstimationProgress,
  showEstimatePopover,
  onTogglePopover,
}) => {
  if (!show || laborEstimationProgress.length === 0) return null;

  const active = laborEstimationProgress.filter(i => i.status === 'pending' || i.status === 'processing').length;
  const done = laborEstimationProgress.filter(i => i.status === 'complete').length;
  const total = laborEstimationProgress.length;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return null;
  //(
  //   <div style={{ position: 'absolute', top: 16, right: 16, zIndex: 10001 }}>
  //     <button
  //       onClick={onTogglePopover}
  //       title="Adding to estimate"
  //       style={{
  //         width: 44,
  //         height: 44,
  //         borderRadius: '999px',
  //         border: 'none',
  //         background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  //         color: '#fff',
  //         display: 'flex',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //         cursor: 'pointer',
  //         boxShadow: '0 4px 16px rgba(16,185,129,0.4)',
  //         position: 'relative',
  //         animation: 'fadeInScale 0.25s ease-out'
  //       }}
  //     >
  //       <Calculator size={20} />
  //       {active > 0 ? (
  //         <span style={{
  //           position: 'absolute', top: -4, right: -4,
  //           minWidth: 18, height: 18, borderRadius: 9,
  //           background: '#065f46', color: '#fff',
  //           fontSize: 11, fontWeight: 700,
  //           display: 'flex', alignItems: 'center', justifyContent: 'center',
  //           padding: '0 5px'
  //         }}>
  //           {active}
  //         </span>
  //       ) : null}
  //     </button>

  //     {showEstimatePopover && (
  //       <div style={{
  //         marginTop: 8,
  //         width: 300,
  //         maxHeight: 320,
  //         overflowY: 'auto',
  //         background: 'var(--bg-primary)',
  //         border: '1px solid var(--border-color)',
  //         borderRadius: 12,
  //         boxShadow: '0 12px 32px rgba(0,0,0,0.22)',
  //         padding: '12px 14px',
  //         animation: 'fadeInScale 0.15s ease-out'
  //       }}>
  //         <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
  //           <Calculator size={14} style={{ color: '#10b981' }} />
  //           Adding to Estimate
  //         </div>
  //         {laborEstimationProgress.map((item, idx) => (
  //           <div
  //             key={`${item.name}-${idx}`}
  //             style={{
  //               display: 'flex',
  //               alignItems: 'center',
  //               justifyContent: 'space-between',
  //               padding: '7px 4px',
  //               borderBottom: idx < laborEstimationProgress.length - 1 ? '1px solid var(--border-subtle)' : 'none'
  //             }}
  //           >
  //             <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
  //               {item.status === 'pending' && <span style={{ fontSize: 13 }}>⏱️</span>}
  //               {item.status === 'processing' && <Loader2 size={13} className="spin" style={{ color: '#10b981' }} />}
  //               {item.status === 'complete' && <span style={{ color: '#059669', fontSize: 14, fontWeight: 700 }}>✓</span>}
  //               {item.status === 'error' && <span style={{ color: '#dc2626', fontSize: 14, fontWeight: 700 }}>✗</span>}
  //               <span style={{ fontSize: 13, color: 'var(--text-secondary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
  //                 {item.name}
  //               </span>
  //             </div>
  //             <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', flexShrink: 0, marginLeft: 8 }}>
  //               {item.count}
  //             </span>
  //           </div>
  //         ))}
  //         <div style={{ marginTop: 10 }}>
  //           <div style={{ height: 6, background: 'var(--border-color)', borderRadius: 3, overflow: 'hidden' }}>
  //             <div style={{
  //               width: `${pct}%`, height: '100%',
  //               background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
  //               transition: 'width 0.4s cubic-bezier(0.4,0,0.2,1)',
  //               borderRadius: 3
  //             }} />
  //           </div>
  //           <div style={{ fontSize: 12, fontWeight: 600, color: '#10b981', textAlign: 'right', marginTop: 4 }}>
  //             {done}/{total}
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );
};
